import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Mail, Phone, MapPin, Twitter, Instagram, Facebook, Youtube, Globe } from "lucide-react";

export default function Footer() {
  const [s, setS] = useState(() => (typeof window !== "undefined" && window.__siteSettings) || {});
  useEffect(() => { api.get("/settings").then(r => setS(r.data)).catch(() => {}); }, []);
  const social = [
    ["twitter_url", Twitter, "Twitter"],
    ["instagram_url", Instagram, "Instagram"],
    ["facebook_url", Facebook, "Facebook"],
    ["youtube_url", Youtube, "YouTube"],
    ["website_url", Globe, "Website"],
  ].filter(([k]) => s[k]);
  const hasContact = s.contact_email || s.phone || s.address;
  const hasSocial = social.length > 0;
  return (
    <footer className="mt-16 text-white border-t-4" style={{ background: "var(--brand-primary)", borderColor: "var(--brand-accent)" }} data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-8 grid grid-cols-1 md:grid-cols-4 gap-8 text-sm">
        <div className="md:col-span-2">
          <h4 className="font-heading text-lg mb-2 tracking-tight" style={{ color: "var(--brand-accent)" }}>
            {s.school_name || s.site_title || "Sports Record Book"}
          </h4>
          {s.mascot && <p className="text-white/70">Home of the {s.mascot}</p>}
          {s.conference && <p className="text-white/70">{s.conference}</p>}
          {s.district && <p className="text-white/70">{s.district}</p>}
          {s.about && <p className="text-white/60 mt-2 max-w-md">{s.about}</p>}
        </div>
        {hasContact && (
          <div>
            <h4 className="font-overline text-xs mb-2" style={{ color: "var(--brand-accent)" }}>Contact</h4>
            {s.contact_email && (
              <a href={`mailto:${s.contact_email}`} className="flex items-center gap-2 hover:underline mb-1" data-testid="footer-contact-email">
                <Mail className="w-3.5 h-3.5"/>{s.contact_email}
              </a>
            )}
            {s.phone && <div className="flex items-center gap-2 mb-1"><Phone className="w-3.5 h-3.5"/>{s.phone}</div>}
            {s.address && <div className="flex items-start gap-2"><MapPin className="w-3.5 h-3.5 mt-0.5"/>{s.address}</div>}
          </div>
        )}
        <div>
          {hasSocial && (
            <>
              <h4 className="font-overline text-xs mb-2" style={{ color: "var(--brand-accent)" }}>Follow</h4>
              <div className="flex flex-wrap gap-2 mb-4">
                {social.map(([k, Icon, label]) => (
                  <a key={k} href={s[k]} target="_blank" rel="noreferrer"
                     className="w-9 h-9 border border-white/30 hover:border-[color:var(--brand-accent)] flex items-center justify-center hover:bg-white/10 transition"
                     title={label} data-testid={`footer-${k}`}>
                    <Icon className="w-4 h-4"/>
                  </a>
                ))}
              </div>
            </>
          )}
          <h4 className="font-overline text-xs mb-2" style={{ color: "var(--brand-accent)" }}>Legal</h4>
          <div className="flex flex-col gap-1">
            <Link to="/privacy" className="hover:underline text-white/80" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="hover:underline text-white/80" data-testid="footer-terms-link">Terms of Service</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-3 text-center text-[11px] text-white/50">
        &copy; {new Date().getFullYear()} {s.school_name || s.site_title || "Sports Record Book"}. Records maintained by the athletics office.
      </div>
    </footer>
  );
}
